import React, { useCallback, useEffect, useRef, useState } from "react";

import styles from "./Modal.module.scss";

import { useModal } from "../../stores/useModel";
import { useDetectOutsideClick } from "../../utils/useDetectOutsideClick";

type Props = {};

function Modal({}: Props) {
  const { showModal, modalContent, setShowModal } = useModal(state => state);
  const modelContainerRef = useRef(null);
  const [mount, setMount] = useState(false);
  const [style, setStyle] = useState({});
  const [overlayStyle, setOverlayStyle] = useState({});

  const onClickOutside = useCallback(() => {
    setShowModal(false);
  }, []);

  useDetectOutsideClick(modelContainerRef, onClickOutside);

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      event.stopPropagation();

      if (event.key === "Escape") {
        setShowModal(false);
      }
    }

    if (showModal) {
      //@ts-ignore
      document.addEventListener("keydown", handleKeyDown);
    }

    let timeoutIndex: null | number = null;
    if (showModal) {
      setMount(true);
      timeoutIndex = window.setTimeout(() => {
        setOverlayStyle({ opacity: "0.75" });
        setStyle({
          opacity: "1",
          transform: "scale(1)",
        });
      }, 20);
    } else {
      setOverlayStyle({ opacity: "0" });
      setStyle({
        opacity: "0",
        transform: "scale(0.5)",
      });

      timeoutIndex = window.setTimeout(() => {
        setMount(false);
      }, 300);
    }

    return () => {
      timeoutIndex && clearTimeout(timeoutIndex);

      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [showModal]);

  return (
    <>
      {mount ? (
        <>
          <div className={styles.overlay} style={overlayStyle} />

          <div className={styles.container}>
            <div ref={modelContainerRef} className={styles.content} style={style}>
              {modalContent}
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}

export default React.memo(Modal);
